import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Carousel, Col, Divider, Form, Row, Steps } from 'antd';
import { CarouselRef } from 'antd/es/carousel';
import React, { useState } from 'react';

import { OnboardHeader } from './OnboardHeader/OnboardHeader';
import { OnboardSkillsStep } from './OnboardSkillsStep/OnboardSkillsStep';
import { OnboardUserStep } from './OnboardUserStep/OnboardUserStep';
import { OnboardVideoStep } from './OnboardVideoStep/OnboardVideoStep';
import { AppLayout } from '../../components/AppLayout/AppLayout';

const NUM_STEPS = 3;

export const OnboardingPage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  // const [completed, setCompleted] = useState(false);

  const [form] = Form.useForm();

  const carouselRef = React.useRef<CarouselRef>(null);

  const handleNext = () => {
    if (currentStep < NUM_STEPS - 1) {
      setCurrentStep(currentStep + 1);
      carouselRef.current?.next();
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      carouselRef.current?.prev();
    }
  };

  return (
    <AppLayout showHeader={false}>
      <Row justify="center">
        <Col span={24}>
          <OnboardHeader />
        </Col>
      </Row>

      <Divider />

      <Row justify="center">
        <Col md={24} lg={14}>
          <Steps progressDot current={currentStep} items={Array(NUM_STEPS).fill({ title: '' })} />

          <Form form={form} size="large" layout="vertical" style={{ marginTop: 16 }}>
            <Carousel ref={carouselRef} dots={false} infinite={false} adaptiveHeight>
              <OnboardUserStep form={form} totalSteps={NUM_STEPS} currentStep={1} />
              <OnboardSkillsStep form={form} totalSteps={NUM_STEPS} currentStep={3} />
              <OnboardVideoStep form={form} totalSteps={NUM_STEPS} currentStep={3} />
            </Carousel>
          </Form>

          <Divider />

          <Row justify="space-between" align="middle">
            <Button
              icon={<LeftOutlined />}
              type="default"
              size="large"
              onClick={handlePrev}
              disabled={currentStep === 0}>
              Previous
            </Button>
            <Button
              icon={<RightOutlined />}
              iconPosition="end"
              type="primary"
              size="large"
              onClick={handleNext}
              disabled={currentStep === NUM_STEPS - 1}>
              Next
            </Button>
          </Row>
        </Col>
      </Row>
    </AppLayout>
  );
};
